import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import { useAuth } from 'context/UseContext';
import { useAuthString } from 'auth/useAuthStorage';

function Finance2() {

  const { user } = useAuth();

  var METABASE_SITE_URL = "https://analytics.galaxyshipping.com";
  const dashboardPermission = process.env.REACT_APP_METABASE_IS_ENABLED;

  const finance2Report = useAuthString('finance2Report');
  let iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + finance2Report + "#bordered=false&titled=true";

  return (
    <Fragment>
      {
        dashboardPermission === "true" ? (
          <>

            {user?.user_type != 'C' && (
              <Box sx={{ height: '100vh' }}><iframe
                src={iframeUrl}
                frameBorder={0}
                width={'100%'}
                height={'100%'}
                allowTransparency
              />
              </Box>

            )}

          </>
        ) : (
          <></>
        )
      }

    </Fragment>);
}

export default Finance2;
